import { benoitApi } from 'apis';
import { useMutation } from 'react-query';

export function useArchiveLaneCards() {
    return useMutation(({boardId, laneId})=> benoitApi.archiveLaneCards(boardId, laneId));
}
